import { useState } from "react"
import BaseForm, { Field } from "./BaseForm"
import styles from "./ContactForm.module.scss"

const CONTACT_PREFERENCES = [
  { value: "email", label: "E-Mail" },
  { value: "phone", label: "Telefon" },
  { value: "none", label: "Keine Präferenz" },
]

const ContactForm = ({ data, content }) => {
  const [contactPreference, setContactPreference] = useState("none")

  return (
    <BaseForm
      data={data}
      content={content}
      formId="contactForm"
      action={`${process.env.NEXT_PUBLIC_API_URL}/!/forms/contact/`}
      submitLabel="Absenden"
      phoneRequired={contactPreference === "phone"}
      onReset={() => setContactPreference("none")}
    >
      <Field id="how-can-we-help" label="Wie können wir Ihnen helfen? *">
        <textarea
          required
          id="how-can-we-help"
          name="how-can-we-help"
          rows={4}
          className={styles.inputFields}
        />
      </Field>

      <Field
        id="contactPreference"
        label="Bevorzugte Kontaktaufnahme"
        contentClassName="mt-1 flex items-center flex-wrap lg:flex-nowrap gap-2 lg:gap-1"
      >
        {CONTACT_PREFERENCES.map(({ value, label }, index) => (
          <label
            key={value}
            className={
              index < CONTACT_PREFERENCES.length - 1
                ? "mr-4 w-full lg:w-auto"
                : "w-full lg:w-auto"
            }
          >
            <input
              className={styles.radioButtons}
              type="radio"
              name="contactPreference"
              value={value}
              onChange={({ target }) => setContactPreference(target.value)}
              defaultChecked={contactPreference === value}
            />{" "}
            {label}
          </label>
        ))}
      </Field>

      <Field
        id="how-did-you-hear-about-us"
        label="Wie haben Sie von uns erfahren?"
      >
        <input
          type="text"
          name="how-did-you-hear-about-us"
          id="how-did-you-hear-about-us"
          className={styles.inputFields}
        />
      </Field>
    </BaseForm>
  )
}

export default ContactForm
